import { guardedClient } from '../../../auth/api/clients';
import fetchAndValidate from '../../../../lib/fetchAndValidate';
import { presignedUrlResponseSchema } from '@minutes-system/backend/src/api/recordings/schema';

const fetchPresignedUrl = async (recordingId: number): Promise<string> => {
  const response = await fetchAndValidate(
    guardedClient.recordings[':id']['presigned-url'].$get({
      param: { id: String(recordingId) },
    }) as Promise<Response>,
    presignedUrlResponseSchema
  );
  return response.presignedUrl;
};

export default fetchPresignedUrl;
